import React, {Component,Fragment} from "react"
import {Link} from "react-router-dom"
import {Checkbox, Col,  FormField, Row, Table,FormInput} from "elemental-react16"
import {Button, Icon, Message,Dropdown,Form} from "semantic-ui-react"
import {withRouter} from "react-router"
import "style/CheckoutPage.scss"
import Price from "components/Price/Price"
import queryString from "qs"
import HeaderCheckout from "pages/checkout/HeaderCheckout";
import shop from "shop/shop"
import ProductTable from "components/Product/ProductTableReadOnly"
import track from "shop/track"
import WordPressContainer from "WordPressContainer"
import languageStore from "stores/languageStore";
import NewCustomerPage from "pages/checkout/NewCustomerPage.js"

@withRouter
class ConfirmationPage extends Component {
    constructor() {
        super()
        this.state = {
            show: false,
            cart: shop.cart,
            agb: false,
            privacy: false,
            confirmationStepActive: false,
            user    : "",
			password: "",
			guest: shop.session.shopuser.guest || "",
			form1Disabled: false,
			form2Disabled: true,
			form3Disabled: true,
			form4Disabled: true,
			form1Check: false,
			form2Check: false,
			form4Check: false,
			newcust: {
				firm: {
					name: "",
					uidnr: "",
					glnnr: "",
					customernumber: ""
				},
				person: {
					salutation: "",
					firstname: "",
					lastname: ""
				},
				address: {
					street: "",
					streetnumber: "",
					addition: "",
					postcode: "",
					city: "",
					country: "",
					deliverstreet: "",
					deliverstreetnumber: "",
					deliveraddition: "",
					deliverpostcode: "",
					delivercity: "",
					delivercountry: ""
				},
				contact: {
					email: "",
					phone: "",
					mobile: "",
					web: "",
					comment: ""
				},
				locale: "",
				deliveraddress: {
					streetnumber: "",
					street: "",
					addition: "",
					pcode: "",
					city: "",
					country: "",
					email: "",
					name1: "",
					name2: "",
					zusatz: "",
					phone: "",
					extras: {
						freecontact: "",
						addition: ""
					}
				},
                addressConfirmation: {
					streetnumber: "",
					street: "",
					addition: "",
					pcode: "",
					city: "",
					country: "",
					email: "",
					name1: "",
					name2: "",
					zusatz: "",
					phone: "",
					extras: {
						freecontact: "",
						addition: ""
					}
				}
			}
        }
        shop.whoami()
        shop.cart.hooks.changed.add(this.update)
    }

    
	  
	  handleUserChange = ( event ) => {
		this.setState( {
		  user: event.target.value
		} )
	  }
	  
	  handlePasswordChange = ( event ) => {
		this.setState( {
		  password: event.target.value
		} )
	  }

  
    update = (cart) => {
        this.setState({cart})
    }

    componentDidMount() {
        track.checkout({step: 3, products: shop.cart.products})

		//console.log("component did mount: ",this.state.confirmationStepActive)
    }

    componentWillUnmount() {
        shop.cart.hooks.changed.remove(this.update)
    }

    handleEnquiry = () => {
        shop.cart.setExtra("is_quotation_request", true)
        this.props.history.push("../success/")
    }

    handleSubmit = async () => {
        if(shop.register){
            shop.register.address.street = shop.register.address.street + ' ' + shop.register.address.streetnumber,
            shop.register.address.street1 = shop.register.address.street
            console.log("shop.register.HandleSubmit: ",shop.register)
            //console.log("handleSubmit shop.register: ",shop.register)
            try {
                await shop.fetch( `/shop/rest/service/request?id=customer_registration`, {
                    method: "POST",
                    body: JSON.stringify( shop.register )
                } )
                shop.session.shopuser.extras.guest = shop.session.shopuser.guest
                /*const delay = ms => new Promise(
                    resolve => setTimeout(resolve, ms)
                  );
                await delay(2000);*/
                if(shop.register.contact.registerMe == true){
                    await shop.fetch( `/shop/rest/data/customertemp/update?finish=1`, {
                        method: "POST",
                        credentials:"include",
                        body: JSON.stringify({"title":shop.register.firm.name,
                                            "street":shop.register.address.street + ' ' + shop.register.address.streetnumber,
                                            "pcode":shop.register.address.postcode,
                                            "city":shop.register.address.city,
                                            "email":shop.register.contact.email})
                    } )

                }
                else{
                    await shop.fetch( `/shop/rest/data/customertemp/update`, {
                        method: "POST",
                        credentials:"include",
                        body: JSON.stringify({"title":shop.register.firm.name,
                                            "street":shop.register.address.street + ' ' + shop.register.address.streetnumber,
                                            "pcode":shop.register.address.postcode,
                                            "city":shop.register.address.city,
                                            "email":shop.register.contact.email})
                    } )
                }
                }
                catch (err) {
                console.log( err )
                shop.toast( err )
                }
        }
		
        shop.cart.setExtra("is_quotation_request", false)
        this.props.history.push("../success/")
    }

    handleAgb = (agb) => {
        console.log(`agb`, agb)
        this.setState({agb})
    }

    handleDatenschutz(privacy) {
        this.setState({privacy})
    }


    toHome = () => {
        this.props.history.push("/home")
    }

    render() {

		//console.log("WHOAMI ",shop.session)
		//console.log("shop.session.value",shop.session.value)

		const query = queryString.parse( this.props.location.search.substr( 1 ) )
		const { overlay } = query
		const { history } = this.props

        let {agb, privacy,confirmationStepActive} = this.state
		const { loading } = shop.cart
        let manual_order_id = shop.cart.getExtra("manual_order_id")
        let attachments = shop.cart.getExtra("attachments")
        let {comment, deliveraddress, deliverdate} = shop.cart.data
        let billingAddress = shop.session.value
        const {checkoutType} = this.props.match.params
        const isRequest = !!checkoutType
        const canOrder = !agb || !privacy || shop.cart.sum <= shop.config.MIN_ORDER_VALUE
        const {hasDeliveryAddress} = shop.cart
        const tax = shop.cart.sum / 100 * Number(shop.config.taxRate)
        const hasTax = shop.config.taxRate
        //console.log("shop.register.REGISTERME: ",shop.register.contact.registerMe)
        //console.log("confirmationStepActive ",confirmationStepActive)
		//console.log("confirmationPage shop: ", shop)
        return (
            <div className="pb4">
				
                {/*shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.custReg && shop.session.value.extras.custReg == true &&
                <Fragment>
                    <HeaderCheckout activeStep={1}/>
                <section className="container pt4 pb4">
                    <div className="row-title tc">
                    </div><br/>
                    <NewCustomerPage/>
                </section>
                </Fragment>*/}             
				{
                <HeaderCheckout activeStep={2}/> }
                {<div className="container ">
				{shop.session.shopuser && shop.session.shopuser.guest && <Link to={{
                pathname: "/checkout/customer/",
                search  : this.props.location.search
              }}>
                <Button
                  loading={loading}
                  primary>
                  {translate( "Ihre Daten bearbeiten" )}
                  <i className="icon-angle-right"/>
                </Button>
              </Link>}
              <br/>
				{/*confirmationStepActive && shop.session.shopuser && shop.session.shopuser.guest &&
					<Fragment><Button style={{ marginLeft: "auto" }} onClick={() => this.handleConfirmationStepActive()} primary>
                    {translate( "Ihre Daten bearbeiten" )}
                    <i className="icon-angle-right"/>
			</Button><br/><br/></Fragment>*/}
                    {/*<Link to="/checkout/delivery"> <Button > <i className="icon-angle-left"/> Zurück </Button></Link>*/}
                    <section>

                        <div className="row-title tl">
                            <h2>{translate("your data")}</h2>
                        </div>

                        <div className="pb3">
                            <Row>
                                {(manual_order_id !== undefined) &&
                                <Col md="1/5" className=""><span className="black-50">{translate("manual_order_id")}</span>
                                    <div className="pt3">
                                        <p className="mb4">{manual_order_id}</p>
                                    </div>
                                </Col>}
                                <Col md="1/5" className=""><span className="black-50">{translate("billing address")} </span>
                                    {billingAddress.title != "Guest" &&<div className="pt3">
                                        <strong> {billingAddress.title}</strong> <br/>
                                        {billingAddress.street} <br/>
                                        {billingAddress.pcode} {billingAddress.city}<br/>
                                        {billingAddress.country}<br/>
                                    </div>}
                                </Col>
                                <Col md="1/5" className=""><span className="black-50">{translate("delivery address")} </span>
                                    <div className="pt3">
                                        {!hasDeliveryAddress && <div className={"b"}>{translate("billing address")}</div>}
                                        {deliveraddress && <div className="mb4">
                                            <strong>{deliveraddress.name1} {deliveraddress.name2} {deliveraddress.name3}</strong><br/>
                                            {deliveraddress.street}<br/>
                                            {deliveraddress.pcode} {deliveraddress.city}<br/>
                                            {deliveraddress.country}<br/>
                                        </div>
                                        }
                                    </div>
                                </Col>
                                <Col md="1/5" className=""><span className="black-50">{translate("payment")}</span>
                                    <div className="pt3">
										<Link className={"mr3"} to={"/cms/zahlungsbedingungen-2024/"}>
										<strong>{translate("Zahlung auf Rechnung")}</strong>
												</Link>
                                    </div>
                                </Col>
                                <Col md="1/5" className=""><span className="black-50">{translate("your comment")}
                                    <div className="pt3">
                  <p className="mb4">{comment ? comment : "-"}</p>
              </div>
              </span></Col>


                                {deliverdate &&
                                <Col md="1/5" className=""><span className="black-50">{translate("delivery after")}
                                    <div className="pt3">
                  <p className="mb4">{deliverdate}</p>
              </div>
              </span></Col>}

                            </Row>
                        </div>

                    </section>


                    <section>

                        {attachments && <Row>
                            <Col>
                                <div className="row-title tl">
                                    <h2>{translate("attachments")}</h2>
                                </div>
                                <p><strong>Logo ID</strong>: {attachments}</p>
                            </Col>
                        </Row>}
                    </section>


                    <section className="overflow-hidden pt3">
                        <div className="row-title tl">
                            <h2>{translate("order items")}</h2>
                        </div>

                        <ProductTable cart={shop.cart} onChange={this.handleChange} products={getProducts()}/>
                        <Table style={{maxWidth: "320px"}} className="fr">
                            <thead>

                            <tr>
                                <td className="tr" colSpan="2">
                                    <span className="black-50 f5"><strong>{shop.cart.size} {translate("positions")} </strong></span>
                                </td>
                            </tr>

                            <tr>
                                <td><span className="f4 b black">{translate("Gesamtsumme*")}</span></td>
                                <td className="f4 b black tr"><Price>{shop.cart.sum}</Price></td>
                            </tr>


                            {/* DISCOUNTS!*/}
                            {(shop.session.handId && !!shop.cart.sumDiscount) &&
                            <React.Fragment>
                                <tr className={"black-60 f5"}>
                                    <td>{translate("Discount")}</td>
                                    <td className="tr"><Price>{shop.cart.sumDiscount}</Price></td>
                                </tr>

                                <tr>
                                    <td><strong>{translate("nach Rabatt")}</strong></td>
                                    <td className="tr"><Price>{shop.cart.sum - shop.cart.sumDiscount}</Price></td>
                                </tr>
                            </React.Fragment>
                            }


                            </thead>
                            <tbody>
                            {hasTax && <tr>
                                <td><span className="f5  ">{translate("zzgl. Steuern")} ({shop.config.taxRate.replace(".", ",")}%)</span></td>
                                <td className="f5   tr"><Price>{tax}</Price></td>
                            </tr>}

                            {hasTax && <tr>
                                <td><span className="f5 b black">{translate("inkl. Steuern")}</span></td>
                                <td className="f5 b  tr"><Price>{tax + shop.cart.sum}</Price></td>
                            </tr>}
                            </tbody>
                        </Table>

                    </section>


                    <section>
                        <div className="mv3">
                            <WordPressContainer
                                className={"ui message mb3"}
                                slug={"confirmation-notice"} postType={"shop"}/>
                        </div>
                    </section>

					<section>
					<div className="container">
								<div className="flex flex-row justify-end">
									{<div className="tr cf dib pb2">
										<Link className={"mr3"} to={"/cms/lieferbedingungen-2024/"}>
										<Message negative className="">
											<div className="total ">
												<div className="ph3">
													<Icon name="info"/>{translate("* Gesamtsumme ")} <strong>{translate("excl. gesetzlicher MwSt. und Frachtkosten.")}</strong>
													 {translate(" Unsere Lieferbedingungen finden Sie hier. Die genauen Frachtkosten erhalten Sie mit der Auftragsbestätigung.")}
												
											</div>
										</div>
									</Message></Link>
								</div>}
								</div>
								</div>
                        {/*<div className="tr">
						<Link target="_blank"
                            to="/cms/lieferbedingungen-2024/">{translate("Bitte beachten Sie, dass alle Preise zzgl. unserer Lieferbedingungen sind.")}</Link>
							<br/>
							</div>*/}
                    </section>

                    <section>
                        <div className="row-title tl">
                            <h2>{translate("Abschluss")}</h2>
                        </div>

                        <div className="tr">
                            <Form type="horizontal">
                                <FormField>
                                    {!agb && <div className="cf dib pb2">
                                        <Message negative className="">
                                            <div className="total ">
                                                <div className="ph3">
                                                    <Icon name="info"/>{translate("please confirm our general terms")}
                                                </div>
                                            </div>
                                        </Message>
                                    </div>}

                                    <div className="tr"><Link target="_blank"
                                                              to="/cms/agb">{translate("AGB")}</Link><br/></div>
															 {<Checkbox className="checkBoxRightCenter" value={agb} onChange={(e) => this.handleAgb(e.target.checked)}
							label={translate("I accept the general terms and conditions")}/>}
                                </FormField>


                                <FormField>

                                    {!privacy && <div className="cf dib pb2">
                                        <Message negative className="">
                                            <div className="total ">
                                                <div className="ph3">
                                                    <Icon name="info"/>{translate("please confirm our privacy information")}
                                                </div>
                                            </div>
                                        </Message>
                                    </div>}
									<div>
                                    {languageStore.locale === "de" &&
                                    <div className="tr"><a
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        href="https://www.orfix.com/de/datenschutz/">{translate("Datenschutzerklärung")}</a><br/>
                                    </div>}

                                    {languageStore.locale === "en" &&
                                    <div className="tr"><a
                                        rel="noopener noreferrer"
                                        target="_blank"
                                        href="https://www.orfix.com/privacy-policy/">{translate("Datenschutzerklärung")}</a><br/>
                                    </div>}

                                    {<Checkbox className="checkBoxRightCenter" value={privacy}
                                              onChange={(e) => this.handleDatenschutz(e.target.checked)}
							label={translate("privacy_notice_notice")}/>}
									{/*<div className="tr relative flex flex-row justify-end ">
									<Checkbox value={privacy}
                                              onChange={(e) => this.handleDatenschutz(e.target.checked)}
                                              />
							<span></span>&nbsp;&nbsp;{translate("privacy_notice_notice")}</div>*/}
									</div>
                                </FormField>


                            </Form>
                        </div>

                        {shop.cart.sum <= shop.config.MIN_ORDER_VALUE &&
                        <div className="cf pb2">
                            <Message negative className="">
                                <div className="total ">
                                    <div className="ph3">
                                        <Icon name="info"/>{translate("minimum order value not reached")}
                                        <span className="pull-right">
                    <Price>{shop.config.MIN_ORDER_VALUE}</Price>
                  </span>
                                    </div>
                                </div>
                            </Message>
                        </div>
                        }
                        {shop.session && shop.session.value && shop.session.value.extras && shop.session.value.extras.custReg && shop.session.value.extras.custReg != true &&
                        <div className="cf pb2">
                            <Message negative className="">
                                <div className="total ">
                                    <div className="ph3">
                                        <Icon name="info"/>{translate("Bitte füllen Sie den oben angegeben Bogen aus, oder melden Sie sich an.")}
                                    </div>
                                </div>
                            </Message>
                        </div>
                        }


                        {!isRequest &&
                        <Button
                            className="fr"
                            disabled={canOrder}
                            primary
                            onClick={this.handleSubmit}
                            style={{
                                paddingLeft: "32px",
                                paddingRight: "32px"
                            }}>{translate("Verbindlich bestellen")}</Button>}

                        {isRequest &&
                        <Button
                            className="fr"
                            primary
                            disabled={canOrder}
                            onClick={this.handleEnquiry}
                            style={{
                                paddingLeft: "32px",
                                paddingRight: "32px"
                            }}>{translate("send enquiry")}</Button>}
                    </section>
                </div>}
            </div>

        )
    }
}

const getProducts = () => shop.cart.map((product) => product)
export default ConfirmationPage



// WEBPACK FOOTER //
// ./src/theme/orfix-test/pages/checkout/ConfirmationPage.js